import upload from "@/services/upload";
import {v4 as uuidv4} from "uuid";
import updateCategory from "@/services/CategoryService/updateCategory";
import addCategory from "@/services/CategoryService/addCategory";
import React from "react";


const saveCategoryStates = {

    validation: {
        main: async (data: any, defaultData: any) => {
            const validationAlert = await defaultData.formRef.current?.validate();
            if (validationAlert) {
                throw new Error('Validation failed intentionally');
            } else return true
        },
        startMessage: () => 'Validate form ...',
        errorMessage: () => 'Some fields are required!'
    },



    form: {
        main: async (data: any, defaultData: any) => {
            return defaultData.formRef.current?.getData()
        },
        startMessage: () => 'Get Category data ...',
    },



    image: {
        main: async (data: any, defaultData: any) => {
            if (data.form.img.url) {
                return data.form.img.url
            } else {
                return await upload({
                    file: data.form.img.string,
                    fileName: `category_${defaultData.currentCategory?.id || uuidv4()}_thumbnail.${data.form.img.fileExtension}`,
                    folderName: `categories`,
                })

            }
        },
        startMessage: () => 'Upload thumbnail ...',
        errorMessage: () => 'Upload thumbnail failed :('
    },



    requestData: {
        main: async (data: any, defaultData: any) => {
            return {
                name: data.form.name,
                description: data.form.description,
                is_active: data.form.isActive || false,
                generic: data.form.isGeneric || false,
                priority: 0,
                show_on_home: data.form.showOnHome || false,
                parent_id: defaultData.currentCategory ? defaultData.currentCategory.parent : defaultData.parentId || null,
                category_image_url: data.image,
                tag_ids: []
            }
        },
        startMessage: () => 'Prepare request ...',
        errorMessage: () => 'Prepare request failed :('
    },



    saveCategory: {
        main: async (data: any, defaultData: any) => {
            if (defaultData.currentCategory) {
                return await updateCategory({
                    ...data.requestData,
                    id: defaultData.currentCategory.id
                })
            } else {
                return await addCategory(data.requestData)
            }
        },
        startMessage: () => `Save Category ...`,
        errorMessage: (error: any) => {
            const errorMessage =
                error.response.data.error ?
                    error.response.data.error.replace(/_/g, " ")
                    :
                    `Save Category failed :( `;
            return <span className={"capitalize"}>{errorMessage}</span>
        }
    },



    updateCategories: {
        main: async (data: any, defaultData: any) => {
            // The v2 envelope is unwrapped by the axios interceptor, so a successful
            // update arrives as { message: "Updated successfully" } while a create
            // arrives as the category object itself. Older flat responses were bare strings.
            const result = data?.saveCategory
            const message = typeof result === 'string' ? result : result?.message
            const saved = !!result?.id || message === "Saved successfully" || message === "Updated successfully"

            if (saved) {
                await defaultData.updateCategoryCallback()
            } else {
                throw new Error('Save category failed :(')
            }
            return data
        },
        startMessage: () => `Load categories ...`,
        errorMessage: () => `Loading failed :(`
    }



}

export default saveCategoryStates